module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img11.27144986.jpg";